import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3ec0416c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3ec0416c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ec0416c')) {
      api.createRecord('3ec0416c', component.options)
    } else {
      api.reload('3ec0416c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3ec0416c", function () {
      api.rerender('3ec0416c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/extra/VabIconSelector/index.vue"
export default component.exports